import { Reveal } from "./Reveal";

const PORTRAIT =
  "https://customer-assets-lxgj4vgw.emergentagent.net/job_su-dharmapala/artifacts/m1kd0zxv_Su%20Dharmapala.png";

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative z-10 bg-alabaster py-24 md:py-36 border-t border-[#DCDEE6]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 grid md:grid-cols-12 gap-12 md:gap-16 items-start">
        <Reveal className="md:col-span-5">
          <div className="relative">
            <div className="overflow-hidden border border-onyx aspect-[4/5]">
              <img
                src={PORTRAIT}
                alt="Su Dharmapala portrait"
                data-testid="about-portrait"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="absolute -bottom-4 -right-4 hidden md:block font-mono text-[10px] tracking-[0.25em] uppercase text-onyx-muted bg-alabaster px-3 py-2 border border-[#DCDEE6]">
              Su Dharmapala
            </div>
          </div>
        </Reveal>

        <div className="md:col-span-7 md:pt-6">
          <Reveal>
            <span className="font-mono text-xs tracking-[0.3em] uppercase text-ochre">
              01 — About
            </span>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-tight mt-6 text-onyx">
              A storyteller working <span className="italic text-ochre">at the seam</span> of page and screen.
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <div className="mt-8 space-y-6 font-sans text-lg leading-relaxed text-onyx-muted max-w-2xl">
              <p>
                Su Dharmapala is a writer and producer whose work moves fluidly between
                literature and the screen. Onyx &amp; Ochre is the home for that practice —
                a studio built on craft, patience and the conviction that the most resonant
                stories are the ones drawn from real earth and lived experience.
              </p>
              <p>
                From original features to returnable series and intimate documentaries,
                Su develops projects with an emphasis on distinctive voice, cultural texture
                and characters who linger long after the final frame. Each project is shepherded
                from the first spark of an idea through development, financing and into production.
              </p>
            </div>
          </Reveal>
          <Reveal delay={0.3}>
            <div className="mt-12 grid grid-cols-3 gap-6 max-w-lg border-t border-[#DCDEE6] pt-8">
              {[
                { k: "Discipline", v: "Writing & Producing" },
                { k: "Formats", v: "Film · TV · Doc" },
                { k: "Approach", v: "Voice-first" },
              ].map((s) => (
                <div key={s.k}>
                  <div className="font-mono text-[10px] tracking-[0.2em] uppercase text-ochre">{s.k}</div>
                  <div className="font-serif text-lg text-onyx mt-2">{s.v}</div>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
